import { ApiState } from "../../../common/constants/api-constants";
import { AddressValidationInfo } from "../../checkout/shop-checkout.interface";

export declare interface StreetValidationRequest {
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zipCode: string;
  country?: string;
}
export declare interface USStreetValidationResponse {
  street1: string;
  street2: string;
  city: string;
  state: string;
  zipCode: string;
  plus4Code: string;
  county: string;
  rdiType: string;
  dpvMatchCode: MatchCode;
  country?: string;
}

export declare interface InternationalStreetValidationResponse {
  street1: string;
  street2: string;
  organization: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  verificationStatus: string;
  addressPrecision: string;
  maxAddressPrecision: string;
}

export declare interface USStreetValidationMagentoResponse {
  content: {
    street1: string;
    street2: string;
    city: string;
    state: string;
    zip_code: string;
    plus4_code: string;
    county: string;
    rdi_type: string;
    dpv_match_code: MatchCode;
    country?: string;
  }
}

export declare interface InternationalStreetValidationMagentoResponse {
  content: {
    street1: string;
    street2: string;
    organization: string;
    city: string;
    state: string;
    zip_code: string;
    country: string;
    verification_status: string;
    address_precision: string;
    max_address_precision: string;
  }
}

export type MatchCode = AddressMatchCode.FullMatch | AddressMatchCode.Invalid | AddressMatchCode.MatchWithoutSecondary;

export enum AddressMatchCode {
  FullMatch = "FULL_MATCH",
  Invalid = "INVALID",
  MatchWithoutSecondary = "MATCH_WITHOUT_SECONDARY"
}

export enum InternationalAddressVerificationStatus {
  Verified = "Verified",
  Ambiguous = "Ambiguous",
  Partial = "Partial"
}

export declare interface AddressValidationState extends ApiState {
  data: AddressValidationInfo | undefined;
}

export interface AddressValidityCheckInput {
  country: string;
  dpvMatchCode?: string;
  validated?: string;
  verificationStatus?: string;
}
